import { lazy } from 'react';

export const LazyApiDashboardPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--api-dashboard-page" */ './api-dashboard-page'
    ),
);
